import React from 'react';
import { usageSteps } from '../data/content';
export function HowItWorks() {
  return <section className="bg-navy-800 px-5 py-16 sm:py-20" data-id="element-83" data-mp="7sllqmrnxfls">
      <div className="mx-auto max-w-5xl" data-id="element-84" data-mp="7u6godhw30k6">
        <div className="mx-auto max-w-2xl text-center" data-id="element-85" data-mp="3pz00gnxr9tl8">
          <h2 className="font-display text-3xl font-black leading-tight text-white sm:text-4xl" data-id="element-86" data-mp="3q0kw6gvt3iko">
            So nutzt du die Bände
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-white/65 sm:text-base" data-id="element-87" data-mp="ljrxbh87v3p1">
            Die Entscheidungen bleiben bei dir: Du prüfst Raum, Material und die
            Bedürfnisse deiner Gruppe.
          </p>
        </div>

        <ol className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-88" data-mp="cr6n4pini5bt">
          {usageSteps.map(step => <li key={step.step} className="flex h-full flex-col rounded-xl border border-white/10 bg-navy-700 p-6" data-id="element-89" data-mp="gs8pvgbs0zij">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gold font-display text-base font-black text-navy-900" data-id="element-90" data-mp="199m8lucw0k76">
                {step.step}
              </span>
              <h3 className="mt-5 font-display text-lg font-extrabold text-white" data-id="element-91" data-mp="2mmuuweeoieby">
                {step.title}
              </h3>
              <p className="mt-auto pt-3 text-sm leading-relaxed text-white/65" data-id="element-92" data-mp="31ciw7fmv1czo">
                {step.description}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}